import React from "react";
import heade from "../Assets/header.png";

const HeaderTitle = ({ Header }) => {
  return (
    <div className="flex flex-col items-center justify-center my-10 px-4">
      <p
        className="relative font-medium text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-center my-6"
        style={{ fontFamily: "'Times New Roman', Serif" }}
      >
        {Header}
      </p>
    </div>

  );
};

export default HeaderTitle;
